
import { defineComponent, useMeta } from '@nuxtjs/composition-api';
const __sfc_main = defineComponent({
  head: {}
});
__sfc_main.setup = (__props, __ctx) => {
  const links = [{
    title: 'Условия гарантии',
    link: '/about/guaranty/warrantly'
  }, {
    title: 'Moneyback. Обмен и возврат без лишних вопросов',
    link: '/about/guaranty/moneyback'
  }, {
    title: 'Обмен/возврат товара, если в вашем городе нет магазина или пункта выдачи 05.ru.',
    link: '/about/guaranty/returns'
  }];
  const lawLinks = [{
    title: 'Статья 18. Права потребителя при обнаружении в товаре недостатков',
    link: 'http://www.zakonrf.info/zozpp/18/'
  }, {
    title: 'Статья 19. Сроки предъявления потребителем требований в отношении недостатков товара',
    link: 'http://www.zakonrf.info/zozpp/19/'
  }, {
    title: 'Статья 20. Устранение недостатков товара изготовителем',
    link: 'http://www.zakonrf.info/zozpp/20/'
  }, {
    title: 'Статья 21. Замена товара ненадлежащего качества',
    link: 'http://www.zakonrf.info/zozpp/21/'
  }, {
    title: 'Статья 22. Сроки удовлетворения отдельных требований потребителя',
    link: 'http://www.zakonrf.info/zozpp/22/'
  }, {
    title: 'Статья 23. Ответственность продавца за просрочку выполнения требований потребителя',
    link: 'http://www.zakonrf.info/zozpp/23/'
  }, {
    title: 'Статья 24. Расчеты с потребителем в случае приобретения им товара ненадлежащего качества',
    link: 'http://www.zakonrf.info/zozpp/24/'
  }, {
    title: 'Статья 26.1. Дистанционный способ продажи товара',
    link: 'http://www.zakonrf.info/zozpp/26.1/'
  }];
  useMeta(() => ({
    title: 'Гарантия и возврат'
  }));
  return {
    links,
    lawLinks
  };
};
export default __sfc_main;
